export default __webpack_public_path__ + "static/media/ceramica.5c8f24af.png";